interface IconProps {
  color?: string;
  handleOnClick?: () => void;
  style?: React.CSSProperties;
}

const Icon = ({ color = "#4FD840", handleOnClick, style = {} }: IconProps) => {
  return (
    <svg
      onClick={handleOnClick}
      style={{ overflow: "visible", ...style }}
      xmlns="http://www.w3.org/2000/svg"
      width="126"
      height="125"
      viewBox="0 0 126 125"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.8226 69.9327C69.2637 69.9327 74.7606 67.656 79.3192 63.1085C83.8778 58.5667 86.1541 53.083 86.1541 46.6575C86.1541 40.232 83.8778 34.7483 79.3192 30.2008C74.7606 25.659 69.2637 23.3823 62.8226 23.3823C56.3815 23.3823 50.8846 25.659 46.3261 30.2008C41.7733 34.7483 39.4969 40.232 39.4969 46.6575C39.4969 53.083 41.7733 58.5667 46.3261 63.1085C50.8846 67.656 56.3815 69.9327 62.8226 69.9327ZM62.8884 9.0644C92.4351 9.0644 116.467 33.0968 116.467 62.6435C116.467 74.0196 112.876 84.5559 106.812 93.2386C94.9316 82.4822 79.6224 75.9832 62.8884 75.9832C46.1601 75.9832 30.88 82.5228 18.9941 93.2791C12.9121 84.5848 9.3093 74.037 9.3093 62.6435C9.3093 33.0968 33.3417 9.0644 62.8884 9.0644ZM62.8887 0.375977C28.5517 0.375977 0.621094 28.3066 0.621094 62.6436C0.621094 96.9805 28.5517 124.911 62.8887 124.911C97.2256 124.911 125.156 96.9805 125.156 62.6436C125.156 28.3066 97.2256 0.375977 62.8887 0.375977Z"
        fill={color}
      />
    </svg>
  );
};

export default Icon;
